export default __webpack_public_path__ + "static/media/fireFN6.74a5e7ea.svg";